import { restClient } from '@/Core'

import type { CrmVerificationTransition } from './CrmVerification'

/**
 * Тіло `verify` (`SPEC-008` §5.4.3, `SPEC-009` Р9.4): uuid юрособи-експедитора
 * договору, номер, дата `YYYY-MM-DD`.
 */
export interface CrmVerifyBody {
    contractForwarder: string
    contractNumber: string
    contractDate: string
}

/** Тіло `reject_verification`: причина, обов'язкова (`SPEC-008` §5.4.1). */
export interface CrmRejectBody {
    comment: string
}

/**
 * Один перехід верифікації — `POST <restUrl>/{uuid}/<перехід>` (`SPEC-008` §6,
 * `SPEC-009` §6.2).
 *
 * Відповідь — оновлена картка власника. `?permissions=true` просить разом із
 * нею `_permissions`: кнопки після переходу мають бути вже нового стану, і
 * без цього параметра картку довелося б перечитувати окремим запитом.
 *
 * Чи можна перехід зараз — вирішує бек (`_permissions`, машина станів);
 * помилки (422 вимог, 400 недозволеного переходу) розбирає `VerificationStore`.
 */
export const RunCrmVerificationTransitionTask = async (
    restUrl: string,
    uuid: string,
    transition: CrmVerificationTransition,
    body: CrmVerifyBody | CrmRejectBody | Record<string, never> = {}
): Promise<Record<string, unknown> | null> => {
    const response = (await restClient.post(`${restUrl}/${uuid}/${transition}?permissions=true`, {
        json: body,
    })) as unknown

    return response !== null && typeof response === 'object' ? (response as Record<string, unknown>) : null
}
